import {
  ref,
  watch,
  computed
} from '@vue/composition-api'
import store from '@/store'

// Notification
import {
  useToast
} from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function allFetchData() {
  // Use toast
  const toast = useToast()

  const refDataTable = ref(null)


  // Table Handlers
  const tableColumns = [{
      key: 'name',
      label: 'nombre',
      sortable: true
    },
    {
      key: 'cloudId',
      label: 'ID_nube',
      sortable: false,
      class: 'no-sort'
    },
    {
      key: 'site.name',
      label: 'Sitio',
      sortable: true
    },
    {
      key: 'model.name',
      label: 'Modelo',
      sortable: true
    },
    {
      key: 'comment',
      label: 'Comentario',
      sortable: false,
      class: 'no-sort'
    },
    {
      key: 'lora',
      label: 'Lora',
      sortable: false,
      class: 'no-sort'
    },
    {
      key: 'enabled',
      label: 'Habilitado',
      sortable: false,
      class: 'no-sort'
    },
    {
      key: 'actions',
      label: 'acciones',
      align: 'center',
      sortable: false,
      class: 'no-sort'
    },
  ]
  const perPage = ref(10)
  const totalData = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('name')
  const isSortDirDesc = ref(false)
  const statusFilter = ref(null)
  const loading = ref(false)
  const dataTypes = [{
      id: 'number',
      name: 'Números'
    },
    {
      id: 'gps',
      name: 'GPS'
    },
    {
      id: 'boolean',
      name: 'Boolenos'
    },
    {
      id: 'list',
      name: 'Listas'
    }
  ]
  const cloudDevices = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refDataTable.value ? refDataTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalData.value,
    }
  })

  const refetchData = () => {
    refDataTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery], () => {
    refetchData()
  })

  const msgError = error => {
    let msg = 'Error al procesar los datos'
    switch (error) {
      case 409:
        msg = 'Ya existe un registro con los mismos datos'
        break
      case 400:
        msg = 'Verifique, datos insuficientes'
        break
      default:
        break
    }
    toast({
      component: ToastificationContent,
      props: {
        title: msg,
        icon: 'AlertTriangleIcon',
        variant: 'danger',
      },
    })
  }

  const msgSuccess = msg => {
    const msgShow = msg || 'Operación realizada con éxito'
    toast({
      component: ToastificationContent,
      props: {
        title: msgShow,
        icon: 'CheckIcon',
        variant: 'success',
        time: 6000,
      },
    })
  }

  const fetchData = (ctx, callback) => {
    loading.value = true
    store
      .dispatch('devices/fetchDevices', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        status: statusFilter.value,
      })
      .then(response => {
        const {
          rows,
          count
        } = response.data
        callback(rows)
        totalData.value = count
        loading.value = false
      })
      .catch(error => {
        console.log(error)
        msgError()
        loading.value = false
      })
  }

  const fetchAdd = (ctx, callback) => {
    loading.value = true
    const data = ctx
    delete data.id
    store
      .dispatch('devices/addDevice', {
        device: data
      })
      .then(response => {
        const device = response.data
        if (refDataTable.value) {
          refDataTable.value.localItems.push(device)
        }
        totalData.value += 1
        msgSuccess()
        loading.value = false
        callback(device)
      })
      .catch(error => {
        console.log(error)
        msgError(error.response.status)
        loading.value = false
      })
  }

  const fetchUpdate = (ctx, callback) => {
    loading.value = true
    store
      .dispatch('devices/updateDevice', {
        id: ctx.id,
        device: ctx
      })
      .then(response => {
        const device = response.data
        const index = refDataTable.value.localItems.findIndex(item => item.id === device.id)
        refDataTable.value.localItems.splice(index, 1, device)
        msgSuccess()
        loading.value = false
        callback(device)
      })
      .catch(error => {
        console.log(error)
        msgError()
        loading.value = false
      })
  }

  const fetchDelete = (ctx, callback) => {
    loading.value = true
    store
      .dispatch('devices/deleteDevice', {
        id: ctx
      })
      .then(response => {
        if (response.status === 204) {
          const index = refDataTable.value.localItems.findIndex(item => item.id === ctx)
          refDataTable.value.localItems.splice(index, 1)
          totalData.value -= 1
          msgSuccess()
          callback(response.statusText)
        }
        loading.value = false
      })
      .catch(error => {
        console.log(error)
        msgError()
        loading.value = false
      })
  }

  const fetchExport = (ctx, callback) => {
    loading.value = true
    store
      .dispatch('devices/fetchExportDevices')
      .then(response => {
        const device = response.data
        msgSuccess()
        callback(device)
        loading.value = false
      })
      .catch(error => {
        console.log(error)
        msgError()
        loading.value = false
      })
  }

  const fetchCloudDevice = (ctx, callback) => {
    loading.value = true
    store
      .dispatch('devices/fetchCloudDevices', {})
      .then(response => {
        cloudDevices.value = response.data
        callback(response.data)
        loading.value = false
      })
      .catch(error => {
        console.log(error)
        msgError()
        loading.value = false
      })
  }

  const fetchDevicesBySite = (ctx, callback) => {
    loading.value = true
    store
      .dispatch('devices/fetchDevicesBySite', {
        site: ctx,
      })
      .then(response => {
        const devices = response.data
        callback(devices)
        loading.value = false
      })
      .catch(error => {
        console.log(error)
        msgError()
        loading.value = false
      })
  }

  const fetchGetLastIoTDataByCloudId = (ctx, callback) => {
    loading.value = true
    store
      .dispatch('devices/fetchGetLastIoTDataByCloudId', {
        cloudId: ctx,
      })
      .then(response => {
        const iotData = response.data
        callback(iotData)
        loading.value = false
      })
      .catch(error => {
        console.log(error)
        msgError()
        loading.value = false
      })
  }
  const fetchDeviceById = (ctx, callback) => {
    loading.value = true
    store
      .dispatch('devices/fetchDevice', {
        id: ctx.id,
        dataKey: ctx.dataKey
      })
      .then(response => {
        const device = response.data
        callback(device)
        loading.value = false
      })
      .catch(error => {
        console.log(error)
        msgError()
        loading.value = false
      })
  }
  const fetchIotDataChart = (ctx, callback) => {
    const {
      cloudId,
      dataKey,
      startDate,
      endDate,
      rangeType,
      sensorType,
      onValue,
      onColor,
      offValue,
      offColor,
      listValues,
    } = ctx
    loading.value = true
    store
      .dispatch('devices/fetchIotDataChart', {
        cloudId,
        dataKey,
        startDate,
        endDate,
        rangeType,
        sensorType,
        onValue,
        onColor,
        offValue,
        offColor,
        listValues,
      })
      .then(response => {
        callback(response.data)
        loading.value = false
      })
      .catch(error => {
        console.log(error)
        msgError()
        loading.value = false
      })
  }

  const fetchLastIotData = (ctx, callback) => {
    const cloudId = ctx
    loading.value = true
    store
      .dispatch('devices/fetchLastIotData', {
        cloudId,
      })
      .then(response => {
        callback(response.data)
        loading.value = false
      })
      .catch(error => {
        console.log(error)
        msgError()
        loading.value = false
      })
  }
  return {
    fetchData,
    fetchAdd,
    fetchUpdate,
    fetchDelete,
    fetchExport,
    fetchCloudDevice,
    fetchDevicesBySite,
    fetchGetLastIoTDataByCloudId,
    tableColumns,
    perPage,
    currentPage,
    totalData,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refDataTable,
    loading,
    refetchData,
    cloudDevices,
    fetchDeviceById,
    fetchIotDataChart,
    fetchLastIotData,
    dataTypes,
  }
}